import { LeftAlignedWrapper, Paragraph } from "App/global-style";
import { StyledIllustration, StyledStbH1 } from "./styled";

import { IllustrationName } from "Constants/constants";
import React from "react";

interface Props {
  title: string;
  paragraphs: string[];
  illustrationName: IllustrationName;
}

export const ErrorPage = ({
  title,
  paragraphs,
  illustrationName,
}: Props): React.ReactElement => (
  <LeftAlignedWrapper>
    <StyledIllustration name={illustrationName} />
    <div>
      <StyledStbH1>{title}</StyledStbH1>
      {paragraphs.map((paragraph) => (
        <Paragraph key={paragraph}>{paragraph}</Paragraph>
      ))}
    </div>
  </LeftAlignedWrapper>
);
